<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { NutsAddress } from '@/utils/address';

export default defineComponent({
  name: 'PostalAddress',
  props: {
    address: { required: true, type: Object as PropType<NutsAddress> },
    highlight: { required: false, type: Boolean, default: false },
  },
  setup() {
    return {};
  },
});
</script>

<template>
  <div class="text-sm leading-4 md:leading-5 md:text-base">
    <div :class="{ 'font-bold': highlight }">{{ address.name }}</div>
    <div v-if="address.company">{{ address.company }}</div>
    <div>{{ address.street1 }}</div>
    <div v-if="address.street2">{{ address.street2 }}</div>
    <div>{{ address.city }}, {{ address.state }} {{ address.postalCode }}</div>
  </div>
</template>
